import config from '~/app/config'

const PROFILES = 'profiles'
const MEASURES = 'measures'
const REGISTRY = 'registry'

const INDEX_MEASURE_PROFILE = 'profile'
const INDEX_MEASURE_PROFILE_DT = 'profile_dt'

function onUpgradeNeed (request) {
  return function () {
    const db = request.result
    if (!db.objectStoreNames.contains(PROFILES)) {
      db.createObjectStore(PROFILES, {
        keyPath: 'id',
        autoIncrement: true
      })
    }
    if (!db.objectStoreNames.contains(MEASURES)) {
      const storeMeasures = db.createObjectStore(MEASURES, {
        keyPath: 'id',
        autoIncrement: true
      })
      storeMeasures.createIndex(INDEX_MEASURE_PROFILE_DT, ['profileId', 'dt'], { unique: true })
      storeMeasures.createIndex(INDEX_MEASURE_PROFILE, 'profileId')
    }
    if (!db.objectStoreNames.contains(REGISTRY)) {
      db.createObjectStore(REGISTRY, {
        keyPath: 'key',
        unique: true
      })
    }
  }
}

export default {
  PROFILES,
  MEASURES,
  REGISTRY,
  INDEX_MEASURE_PROFILE,
  INDEX_MEASURE_PROFILE_DT,
  open () {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open(config.dbName, 1)
      request.onupgradeneeded = onUpgradeNeed(request)
      request.onsuccess = function () {
        const db = request.result
        db.onversionchange = () => {
          db.close()
          alert('База данных устарела, пожалуста, перезагрузите страницу.')
        }
        db.onerror = function (event) {
          let request = event.target // запрос, в котором произошла ошибка
          console.log('Ошибка', request.error)
        }
        resolve(db)
      }
      request.onerror = reject
    })
  },
  get (storeName, id) {
    return new Promise((resolve, reject) => {
      return this.open().then(db => {
        let transaction = db.transaction(storeName)
        let store = transaction.objectStore(storeName)
        let request
        if (typeof id === 'function') {
          request = id(store)
        } else {
          request = store.get(id)
        }
        request.onsuccess = () => {
          // console.log('Request result', storeName, request.result)
          resolve(request.result)
        }
        request.onerror = () => {
          reject(request.error)
        }
      })
    })
  },
  getAll (storeName) {
    return new Promise((resolve, reject) => {
      return this.open().then(db => {
        let transaction = db.transaction(storeName)
        let store = transaction.objectStore(storeName)
        let request = store.getAll()
        request.onsuccess = () => {
          resolve(request.result)
        }
        request.onerror = () => {
          reject(request.error)
        }
      })
    })
  },
  remove (storeName, id) {
    return new Promise((resolve, reject) => {
      return this.open().then(db => {
        let transaction = db.transaction(storeName, 'readwrite')
        let store = transaction.objectStore(storeName)
        let deleteRequest
        if (typeof id === 'function') {
          deleteRequest = id(store)
        } else {
          deleteRequest = store.delete(id)
        }
        deleteRequest.onsuccess = function () {
          resolve(deleteRequest.result)
        }
        deleteRequest.onerror = () => {
          reject(deleteRequest.error)
        }
      })
    })
  },
  save (storeName, item, isAdd = true) {
    return new Promise((resolve, reject) => {
      return this.open().then(db => {
        let transaction = db.transaction(storeName, 'readwrite')
        let store = transaction.objectStore(storeName)
        let request
        if (isAdd) {
          // console.log('STORE ' + storeName + ' ADD ', item)
          request = store.add(item)
        } else {
          // console.log('STORE ' + storeName + ' PUT ', item)
          request = store.put(item)
        }
        request.onsuccess = function () {
          resolve(request.result)
        }
        request.onerror = () => {
          reject(request.error)
        }
      })
    })
  }
}
